module.exports = __webpack_public_path__ + "static/media/www.oldirishpub.fifipageetusivu.0b6e10dc.png";